import { createAsyncThunk } from '@reduxjs/toolkit'
import { FetchInvitedTeamMemberParams } from './types'
import axios from '../../../../config/axios'

export const fetchInvitedTeamMembers = createAsyncThunk(
  'invitedTeamMemberPerEvent/fetchInvitedTeamMembers',
  async (params: FetchInvitedTeamMemberParams, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/report/event/${params.eventId}/invitedTeamMember`)
      return response.data
    } catch (error) {
      return rejectWithValue('Failed to fetch invited team members')
    }
  },
)
